<template>
  <div class="exhibitorCenter">
    <div class="userInfo">
      <div class="register_header">
        <img src="../../assets/image/header.jpg" alt />
      </div>

      <!-- content -->
      <div class="exhibitor">
        <div class="exhibitorContent_left">
          <div class="exhibitor_logo">
            <p>
              <img :src="$getSrc(this.$store.state.userInfo.cLogo)" alt />
            </p>
            <p>{{ this.$store.state.userInfo.cName }}</p>
            <el-button type="primary" class="goHome" @click="intoHome">进入主页</el-button>
          </div>
          <div class="ul_title">
            <ul>
              <router-link v-for="(item,index) in tabList" :key="index" :to="item.url">
                <li class="li_a">
                  <p class="line-p" v-if="item.name === currentTab"></p>
                  {{ item.title }}
                </li>
              </router-link>
            </ul>
          </div>
          <el-button class="tc_btn" @click="backHome">退出返回首页</el-button>
        </div>
        <div class="exhibitorContent_right">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import myFooter from "../Footer";
export default {
  components: {
    myFooter,
  },
  watch: {
    $route(val) {
      this.currentTab = val.name;
    },
  },
  mounted() {
    this.currentTab = this.$route.name;
  },
  data() {
    return {
      currentTab: "notice",
      tabList: [
        { title: "通知公告", url: "/exhibitorCenter", name: "notice" },
        {
          title: "展商资料",
          url: "/exhibitorCenter/information",
          name: "exInformation",
        },
        {
          title: "产品中心",
          url: "/exhibitorCenter/product",
          name: "exProduct",
        },
        {
          title: "资讯管理",
          url: "/exhibitorCenter/realtime",
          name: "realtime",
        },
        { title: "案例管理", url: "/exhibitorCenter/case", name: "exCase" },
        {
          title: "留言板管理",
          url: "/exhibitorCenter/messageBoard",
          name: "messageBoard",
        },
        {
          title: "广告设置",
          url: "/exhibitorCenter/advertisement",
          name: "advertisement",
        },
		{
		  title: "视频管理",
		  url: "/exhibitorCenter/videoManagement",
		  name: "videoManagement",
		},
        {
          title: "更改密码",
          url: "/exhibitorCenter/resetPassword",
          name: "resetPassword",
        },
      ],
    };
  },
  methods: {
    backHome() {
      this.$confirm("确认退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //确认退出后 删除浏览器cookie,删除token状态,返回至登录页.
          this.$cookie.delete("mkToken");
          this.$store.commit("SET_TOKEN", "");
          this.$router.replace("/login");
        })
        .catch(() => {});
    },
    intoHome() {
      // this.$router.push({
      //   path: "/exhibitorHome",
      //   // query: {
      //   //   id: this.$store.state.userInfo.id,
      //   // },
      // });
      sessionStorage.setItem("accountId",this.$store.state.userInfo.id);
      window.open(this.$windowOpenUrl + "exhibitorHome");
    },
  },
  beforeRouteLeave(to, form, next) {
    // this.$cookie.delete("mkToken");
    // this.$store.commit("SET_TOKEN", "");
    next();
  },
};
</script>
<style lang="scss" scoped>
.exhibitorCenter {
  width: 100%;
  .userInfo {
    width: 1200px;
    margin: 0 auto;
  }
  .register_header {
    width: 100%;
    height: 132px;
    img {
      margin-top: 21px;
    }
  }

  // content
  .exhibitor {
    width: 100%;
    .exhibitorContent_left {
      width: 258px;
      height: 751px;
      float: left;
      .exhibitor_logo {
        width: 100%;
        height: 240px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        color: #333333;
        p:first-child {
          width: 80px;
          height: 80px;
          margin: 35px auto 40px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        p:last-child {
          // overflow: hidden;
        }
      }
      .ul_title {
        width: 100%;
        // height: 420px;
		 height: 486px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        margin: 20px 0;
        .li_a {
          width: 228px;
          height: 52px;
          line-height: 52px;
          font-size: 14px;
          color: #333333;
          position: relative;
          padding-left: 30px;
          &:hover {
            background-color: #143372;
            color: #ffffff;
          }
        }
        // 点击不同按钮添加的高亮
        .line-p {
          width: 3px;
          height: 32px;
          background-color: #143372;
          position: absolute;
          top: 10px;
          left: 0;
        }
      }
      .tc_btn {
        width: 200px;
        height: 50px;
        background-color: #143372;
        color: #ffffff;
        font-size: 14px;
        margin: 0 auto;
        margin-left: 30px;
      }
    }
    .exhibitorContent_right {
      width: 920px;
      min-height: 750px;
      margin-bottom: 81px;
      float: right;
      box-shadow: 0px 0px 10px 8px #f3f3f3;
      position: relative;
    }
  }
  .goHome {
    background-color: #143372;
    border: none;
    margin-top: 15px;
  }
}
</style>